import React, { Component } from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../store/rootReducer';
import i18n from '../../i18n';
import HelpTooltip from '../../components/overlays/helpTooltip/HelpTooltip';
import ConfigurationsBlazeTable from './ConfigurationsBlazeTable';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import BzmIcon from '../../components/icons/BzmIcon';
import Row from 'react-bootstrap/Row';
import {
  setCurrentConfiguration,
  setExpandedConfiguration,
  setIsCreatingConfiguration,
} from '../../store/configurations/configurationsReducer';
import { bulkDeleteConfigurationsAction } from '../../store/configurations/configurationsActions';
import { Configuration } from '../../types/rest/configurationsType';
import { confirm } from '../../components/ui/modal/BlazeConfirmationModal';
import { getSelectedCountTitle } from '../../utils/miscUtil';

type AllProps = MapToStateProps & DispatchProps;

interface LocalState {
  selectedConfigurations: Configuration[];
}

class Configurations extends Component<AllProps, LocalState> {
  // @ts-ignore
  confListTableRef: any = React.createRef<ConfigurationsBlazeTable>();

  state: LocalState = {
    selectedConfigurations: [],
  };

  onNewConfiguration = () => {
    if (this.props.isCreatingNewConfiguration === false) {
      this.props.setIsCreatingConfiguration(true);
      this.props.setCurrentConfiguration(null);
    }
  };

  onSelectionChange = (selected: Configuration[]) => {
    this.setState({ selectedConfigurations: selected });
  };

  onBulkDeleteClicked = () => {
    const count = this.state.selectedConfigurations.length;
    const modalBody = (
      <p>
        {count === 1
          ? i18n.t('configurations:configurationsTable.bulkDelete.confirmBodySingle', { count })
          : i18n.t('configurations:configurationsTable.bulkDelete.confirmBodyMultiple', { count })}
        <br />
        {i18n.t('configurations:configurationsTable.bulkDelete.cannotUndo')}
      </p>
    );
    confirm({
      confirmation: modalBody,
      yesOptionTitle: i18n.t('common:actions.delete'),
      title: i18n.t('configurations:configurationsTable.bulkDelete.confirmTitle'),
    })
      .then(async () => {
        await this.props.bulkDeleteConfigurationsAction(this.state.selectedConfigurations);
        this.setState({ selectedConfigurations: [] });
        if (this.confListTableRef && this.confListTableRef.deSelectAll) {
          this.confListTableRef.deSelectAll();
        }
      })
      .catch(() => {
        // User chose "No"
      });
  };

  render = () => {
    const totalCount = this.props.configurations.length;
    const selectedCount = this.state.selectedConfigurations.length;
    const headerText = getSelectedCountTitle(totalCount, selectedCount);
    const isBulkDeleteDisabled = selectedCount === 0 || this.props.isPrivateCloudReadOnly || this.props.isBulkDeleting;

    return (
      <div className="container-fluid">
        <div id="configurations-card" className="card mb-0 flex-grow-1">
          <div className="card-body">
            <Row className="align-items-end mb-2">
              <Col sm={10}>
                <div>
                  <h2>
                    {i18n.t('configurations:header.title')} {headerText}
                    <HelpTooltip
                      id={'configurations_help'}
                      title={i18n.t('common:showHelp')}
                      className="ml-3"
                    />
                    <button
                      id="qa-blk-cfg-delete"
                      type="button"
                      className="btn btn-link btn-no-hover p-0 mx-2"
                      title={i18n.t('configurations:configurationsTable.bulkDelete.confirmTitle')}
                      aria-label={i18n.t('configurations:configurationsTable.bulkDelete.confirmTitle')}
                      onClick={this.onBulkDeleteClicked}
                      disabled={isBulkDeleteDisabled}
                    >
                      <BzmIcon variant={'icon-bzm-delete'} className={'icon-sm'} />
                    </button>
                  </h2>
                  <p>{i18n.t('configurations:header.description')}</p>
                </div>
              </Col>
              <Col sm={2} className="text-sm-right">
                <Button
                  disabled={false}
                  className="btn btn-primary btn-circular btn-jb"
                  title={i18n.t('configurations:createNewConfiguration')}
                  onClick={() => this.onNewConfiguration()}
                >
                  <BzmIcon variant={'icon-bzm-add'} />
                </Button>
              </Col>
            </Row>
            <ConfigurationsBlazeTable
              onRef={(ref: any) => (this.confListTableRef = ref)}
              onSelectionChange={this.onSelectionChange}
            />
          </div>
        </div>
      </div>
    );
  };
}

const mapStateToProps = ({ configurations, blazeUserConfig }: ApplicationState) => ({
  isCreatingNewConfiguration: configurations.isCreatingNewConfiguration,
  currentConf: configurations.currentConfiguration,
  configurations: configurations.configurations,
  isPrivateCloudReadOnly: blazeUserConfig.isPrivateCloudReadOnly,
  isBulkDeleting: configurations.isBulkDeleting,
});

const mapDispatchToProps = {
  setExpandedConfiguration,
  setIsCreatingConfiguration,
  setCurrentConfiguration,
  bulkDeleteConfigurationsAction,
};
type MapToStateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;
export default connect(mapStateToProps, mapDispatchToProps)(Configurations);
